import { render, staticRenderFns } from "./AIResultsModal.vue?vue&type=template&id=4fb7ff67&scoped=true"
import script from "./AIResultsModal.vue?vue&type=script&lang=js"
export * from "./AIResultsModal.vue?vue&type=script&lang=js"
import style0 from "./AIResultsModal.vue?vue&type=style&index=0&id=4fb7ff67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7ff67",
  null
  
)

export default component.exports